import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { countries } from './countries';
import styles from './CountryAutocomplete.module.scss';
export const CountryAutocomplete = ({ onSelect, value = '', disabled = false, }) => {
    const havenStyle = {
        border: `1px solid ${disabled ? 'rgb(216, 216, 216)' : '#007cc2'}`,
        borderRadius: '$spacing-1',
        height: '50px',
        boxShadow: '0 0 0 0 transparent',
        iconColor: '#007cc2',
        color: '#031545',
        zIndex: 2,
        fontSize: '$spacing-4',
        placeholderColor: '#007cc2',
    };
    const fuseOptions = {
        keys: ['name', 'code', 'alt'],
        threshold: 0.3,
        findAllMatches: true,
        ignoreLocation: true,
    };
    const [selectedCountry, setSelectedCountry] = useState(null);
    useEffect(() => {
        setSelectedCountry(countries.find((c) => c.code === value) || null);
    }, [value]);
    const countryFormatResult = (item) => {
        return (<div className={styles.resultWrapper}>
        <span>{item.name}</span>
        <span> ({item.code})</span>
      </div>);
    };
    const getInputElement = () => document.querySelector('#country-selector input');
    const onFocus = () => {
        getInputElement().setAttribute('autocomplete', 'nope');
    };
    const handleOnClear = () => {
        setTimeout(() => {
            const input = getInputElement();
            input === null || input === void 0 ? void 0 : input.blur();
            input === null || input === void 0 ? void 0 : input.focus();
            input.removeAttribute('disabled');
            onSelect('');
        }, 0);
    };
    useEffect(() => {
        if (selectedCountry || disabled) {
            getInputElement().setAttribute('disabled', 'disabled');
        }
    }, [selectedCountry, disabled]);
    return (<div className={styles.root}>
      <div className={clsx(styles.autocompleteWrapper, disabled && styles.disabled)} id='country-selector'>
        <div className={styles.label}>
          <span>Country</span>
        </div>
        <ReactSearchAutocomplete items={countries} onSelect={(country) => onSelect(country.code)} maxResults={5} fuseOptions={fuseOptions} showIcon={false} inputDebounce={0} formatResult={(item) => countryFormatResult(item)} placeholder='Search by country name' inputSearchString={selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.name} styling={havenStyle} onFocus={() => onFocus()} onClear={() => handleOnClear()} autoFocus={false} showNoResults={false} showClear={!disabled}/>
      </div>

      {!selectedCountry && (<p className={styles.error}>
          This field is required, search and select a country from the list
        </p>)}
    </div>);
};
